import React from 'react';

import dayjs from '~/timeInit';

import { Box, Typography } from '@mui/material';

import { LereToursPricingSuggestion } from '../types';

function formatDate(value: string | null): string {
  if (!value) {
    return '—';
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('DD/MM/YYYY') : value;
}

function formatNumber(value: number | null): string {
  if (value == null) {
    return '—';
  }
  return value.toLocaleString();
}

export default function ToursScheduleFormatter({ row }: { row: LereToursPricingSuggestion }) {
  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Handback:
        </Typography>{' '}
        {formatDate(row.handback_date)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Leadtime:
        </Typography>{' '}
        {formatNumber(row.leadtime)}
      </Typography>
    </Box>
  );
}
